import React, { useState } from "react";
import { Theme } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Header from "./Header";
import SideBar from "./SideBar";
import { isMobile } from "react-device-detect";

const Layout = ({ children }: any) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const onMenuClick = () => {
    setDrawerOpen(drawerOpen => !drawerOpen);
  };

  return (
    <Grid container className='layout-root' spacing={0} direction="row">
      {!isMobile && (
        <Grid container spacing={0} className='sidebar-container'>
          <SideBar open />
        </Grid>
      )}
      <Grid container spacing={0} className='content-container'>
        
        {isMobile && <SideBar open={drawerOpen} onMenuClick={onMenuClick} />}
        <main className='main'>{children}</main>
      </Grid>
    </Grid>
  );
};

export default Layout;